import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=0e17f27e&scoped=true"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"
import style0 from "./Providers.vue?vue&type=style&index=0&id=0e17f27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e17f27e",
  null
  
)

export default component.exports